import React from "react";
import { ReactComponent as ScrollArrow } from "assets/scroll-arrow.svg";
import "./style.css";
import MainHeadingText from "components/Main-Heading-Text";
const HeroSection = () => {
  return (
    <>
      <p className='text-light2 dark:text-dark2 text-lg md:text-3xl uppercase font-medium mt-8'>
        Momin Naveed
      </p>
      <div className='mt-8'>
        <MainHeadingText text='Frontend' />
        <MainHeadingText text='Titan' direction='right' />
      </div>
      <div className='mt-8 md:mt-16 flex flex-col md:flex-row gap-8 md:gap-0 justify-between md:items-center'>
        <div className='flex items-center'>
          <div className='scroll-outer-container'>
            <div className='relative scroll-container'>
              <ScrollArrow className='absolute top-0 left-0 scroll-icon-2 fill-dark1 dark:fill-light1' />
              <ScrollArrow className='absolute top-0 left-0 scroll-icon fill-dark1 dark:fill-light1' />
            </div>
          </div>
          <p className='text-base md:text-xl w-16 text-dark1 dark:text-light1'>
            Keep Scrolling
          </p>
        </div>
        <div className='text-right'>
          <p className='text-base md:text-xl text-dark1 dark:text-light1'>
            Available for work
          </p>
          <p className='text-base md:text-xl text-dark1 dark:text-light1'>Since Jan 2018</p>
          <button
            className='text-base md:text-xl text-dark1 dark:text-light1 uppercase font-medium relative talk-heading hover:font-semibold hover:tracking-[.125em]'
            onClick={(e) => {
              window.location.assign(
                "mailto:mominnaveed1997@gmail.com?subject=Lets%20work%20together!&amp;body=Hello%2C%20I%20think%20we%20need%20you%20to%20work%20on%2Fcollaborate%20this%20particular%20product...%20Reach%20out%20as%20soon%20as%20you%20can.",
              );
            }}
          >
            Let's Talk.
            <div className='button-underline-div bg-dark dark:bg-light'></div>
          </button>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
